import {html} from 'lit';
import '@vaadin/text-field/theme/material/vaadin-text-field.js';

export const renderField = (label, value, colspan = 1) => html`
    <vaadin-form-item colspan=${colspan}>
        <label slot="label">${label}</label>
        <vaadin-text-field
            style="width: 100%;"
            readonly
            value=${value}
        ></vaadin-text-field>
    </vaadin-form-item>
`;

export const getStatusColor = (status) => {
    switch (status) {
        case 'accepted':
            return 'green';
        case 'badResponse':
        case 'error':
        case 'notValid':
        case 'failed':
            return 'red';
        case 'pending':
            return 'blue';
        default:
            return 'grey';
    }
};

// The Learning API has no result yet for an accreditation that still has to be sent to PE-online.
export const getResultStatus = (accreditation) => accreditation.result?.resultStatus ?? 'pending';

// Anything PE-online did not accept can be sent again; that needs the id of the stored accreditation.
export const canRetryAccreditation = (accreditation) =>
    Boolean(accreditation?.id) && getResultStatus(accreditation) !== 'accepted';

// The row after a retry: the Learning API returns what changed (result, previous result, data, points,
// processed date); the rest (display name, course name) stays as it was.
export const mergeRetriedAccreditation = (accreditation, retried) => ({
    ...accreditation,
    ...retried,
});

// Messages of accreditation/locales that read differently when users retry their own accreditation
// in their portfolio ("de registratienummers in je profiel") than when an admin does it for them.
const SELF_VARIANTS = new Set(['dialogBody', 'noUserRegistration', 'noApplicableMapping']);

export const retryMessageKey = (name, own = false) =>
    own && SELF_VARIANTS.has(name)
        ? `accreditationRetry.self.${name}`
        : `accreditationRetry.${name}`;

// Names in accreditation/locales for the reasons the Learning API refuses a retry (422/409 `reason`).
const RETRY_REASON_KEYS = {
    alreadyAccepted: 'alreadyAccepted',
    noUserRegistration: 'noUserRegistration',
    noApplicableMapping: 'noApplicableMapping',
};

export const getRetryErrorKey = (error, own = false) =>
    retryMessageKey(RETRY_REASON_KEYS[error?.reason] ?? 'failed', own);

export function getValidMappings(mappings) {
    if (!mappings?.length) {
        return [];
    }

    const now = new Date();

    return mappings.reduce((memo, m) => {
        if (
            (!m.validFrom || now >= new Date(m.validFrom)) &&
            (!m.validTill || now <= new Date(m.validTill))
        ) {
            memo.push(m);
        }

        return memo;
    }, []);
}
